import { _ as t } from "../internals/export.js";
import { f as r } from "../internals/function-uncurry-this-clause.js";
import "../internals/object-get-own-property-descriptor.js";
import { t as o } from "../internals/to-length.js";
import { t as s } from "../internals/to-string.js";
import { n as e } from "../internals/not-a-regexp.js";
import { r as i } from "../internals/require-object-coercible.js";
import { c as n } from "../internals/correct-is-regexp-logic.js";
import { __exports as a } from "../../../_virtual/object-get-own-property-descriptor.js";
var p,
  l = a.f,
  m = r("".startsWith),
  c = r("".slice),
  f = Math.min,
  g = n("startsWith");
t({
  target: "String",
  proto: !0,
  forced: !(!g && (p = l(String.prototype, "startsWith")) && !p.writable) && !g
}, {
  startsWith: function startsWith(t) {
    var r = s(i(this));
    e(t);
    var n = o(f(arguments.length > 1 ? arguments[1] : void 0, r.length)),
      a = s(t);
    return m ? m(r, a, n) : c(r, n, n + a.length) === a;
  }
});